import {Tab, Tabs, Box, styled} from '@mui/material'
import {useState} from 'react'
import {useI18n} from 'store/Store'
import TabContent from './TabContent'
import FilmedDates from './FilmedDates'
import DownloadsReport from './DownloadsReport'

const DownloadsTabs = () => {
    const {i18n} = useI18n()

    const [value, setValue] = useState(0)

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    const a11yProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        }
    }

    return (
        <Container>
            <TabsWrapper>
                <StyledTabs
                    value={value}
                    onChange={handleChange}
                    aria-label="reports"
                    variant="scrollable"
                    scrollButtons="auto"
                    TabIndicatorProps={{
                        style: {height: 3},
                    }}>
                    <StyledTab
                        label={i18n.t('dashboard.downloadsReport')}
                        {...a11yProps(0)}
                    />
                    <StyledTab
                        label={i18n.t('dashboard.filmedDateDownload')}
                        {...a11yProps(1)}
                    />
                </StyledTabs>
            </TabsWrapper>
            <TabContent value={value} index={0}>
                <DownloadsReport />
            </TabContent>
            <TabContent value={value} index={1}>
                <FilmedDates />
            </TabContent>
        </Container>
    )
}

export default DownloadsTabs

const Container = styled(Box)`
    width: 100%;
`

const TabsWrapper = styled(Box)`
    border-bottom: 2px solid ${({theme}) => theme.palette.divider};
    margin-bottom: ${({theme}) => theme.spacing(3)};
`

const StyledTabs = styled(Tabs)`
    & .MuiTabs-flexContainer {
        justify-content: start;

        ${({theme}) => theme.breakpoints.down('sm')} {
            justify-content: flex-start;
        }
    }
`

const StyledTab = styled(Tab)`
    text-transform: none;
    font-weight: 600;
    font-size: 1rem;
    min-height: 56px;
    min-width: 160px;
    padding: ${({theme}) => theme.spacing(1.5, 4)};
    transition: all 0.2s ease-in-out;

    &:hover {
        background-color: ${({theme}) => theme.palette.action.hover};
    }

    &.Mui-selected {
        color: ${({theme}) => theme.palette.primary.main};
        font-weight: 700;
    }

    ${({theme}) => theme.breakpoints.down('sm')} {
        font-size: 0.875rem;
        min-width: 140px;
        padding: ${({theme}) => theme.spacing(1.5, 2)};
    }
`
